import AnionTestingPart from './AnionTestingPart';

export default function Part3Bromide() {
  return (
    <AnionTestingPart
      partNumber={3}
      anionSymbol="Br-"
      anionName="Bromide"
      anionFormula="0.1 M NaBr"
      anionColor="#FFECB3"
      infoContent={{
        title: 'Bromide Solubility',
        content: 'Like chlorides, most bromides are soluble. Silver bromide forms a cream/pale yellow precipitate - slightly different from white AgCl.',
        equation: 'Ag+(aq) + Br-(aq) -> AgBr(s) [cream/pale yellow]'
      }}
    />
  );
}
